"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMStatementBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../interfaces/vm-transformers/IVMScopeManager");
const IVMLoopCompiler_1 = require("../../../interfaces/vm-transformers/compilers/loops/IVMLoopCompiler");
const IVMConditionalCompiler_1 = require("../../../interfaces/vm-transformers/compilers/conditionals/IVMConditionalCompiler");
const IVMExceptionCompiler_1 = require("../../../interfaces/vm-transformers/compilers/exceptions/IVMExceptionCompiler");
const IVMDeclarationCompiler_1 = require("../../../interfaces/vm-transformers/compilers/declarations/IVMDeclarationCompiler");
const IVMClassBytecodeCompiler_1 = require("../../../interfaces/vm-transformers/compilers/IVMClassBytecodeCompiler");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../node/NodeGuards");
const VMConstants_1 = require("../../VMConstants");
let VMStatementBytecodeCompiler = class VMStatementBytecodeCompiler {
    constructor(vmCompilerUtils, loopCompiler, conditionalCompiler, exceptionCompiler, declarationCompiler, classCompiler, scopeManager) {
        this.vmCompilerUtils = vmCompilerUtils;
        this.loopCompiler = loopCompiler;
        this.conditionalCompiler = conditionalCompiler;
        this.exceptionCompiler = exceptionCompiler;
        this.declarationCompiler = declarationCompiler;
        this.classCompiler = classCompiler;
        this.scopeManager = scopeManager;
    }
    compileBlockStatement(node, context) {
        var _a, _b;
        const blockVariables = [];
        let needsEnvironment = false;
        let envHandle = null;
        const isFunctionBody = context.isFunctionBody;
        if (isFunctionBody) {
            context.isFunctionBody = false;
        }
        const containsFunctions = !isFunctionBody && this.vmCompilerUtils.containsFunction(node);
        if (containsFunctions) {
            for (const statement of node.body) {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(statement)) {
                    if (statement.kind === 'let' || statement.kind === 'const') {
                        for (const declaration of statement.declarations) {
                            if (NodeGuards_1.NodeGuards.isIdentifierNode(declaration.id)) {
                                const varName = declaration.id.name;
                                needsEnvironment = true;
                                blockVariables.push(varName);
                            }
                            else if (NodeGuards_1.NodeGuards.isArrayPatternNode(declaration.id) ||
                                NodeGuards_1.NodeGuards.isObjectPatternNode(declaration.id)) {
                                const patternVarNames = this.vmCompilerUtils.extractIdentifiersFromPattern(declaration.id);
                                for (const varName of patternVarNames) {
                                    needsEnvironment = true;
                                    blockVariables.push(varName);
                                }
                            }
                        }
                    }
                }
            }
        }
        if (needsEnvironment) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            for (const varName of blockVariables) {
                for (let depth = context.blockScopeDepth; depth >= 0; depth--) {
                    const scopedKey = (0, VMConstants_1.getScopedVariableName)(varName, depth);
                    if (context.localVariables.has(scopedKey)) {
                        if (!context.envVars.has(varName)) {
                            const localIndex = context.localVariables.get(scopedKey);
                            if (localIndex !== undefined) {
                                builder.loadLocal(localIndex);
                                builder.storeToEnvByName(varName);
                                context.envVars.add(varName);
                            }
                        }
                        else {
                            builder.loadFromEnvByName(varName);
                            builder.storeToCurrentEnvByName(varName);
                        }
                        break;
                    }
                }
            }
            envHandle = this.scopeManager.enterEnv(context, builder);
            for (const varName of blockVariables) {
                context.envVars.add(varName);
            }
        }
        const blockHandle = this.scopeManager.enterBlock(context);
        const blockTDZVars = [];
        if (!isFunctionBody) {
            for (const statement of node.body) {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(statement)) {
                    if (statement.kind === 'let' || statement.kind === 'const') {
                        for (const declaration of statement.declarations) {
                            if (NodeGuards_1.NodeGuards.isIdentifierNode(declaration.id)) {
                                const varName = declaration.id.name;
                                blockTDZVars.push(varName);
                            }
                            else if (NodeGuards_1.NodeGuards.isArrayPatternNode(declaration.id) ||
                                NodeGuards_1.NodeGuards.isObjectPatternNode(declaration.id)) {
                                const patternVarNames = this.vmCompilerUtils.extractIdentifiersFromPattern(declaration.id);
                                for (const varName of patternVarNames) {
                                    blockTDZVars.push(varName);
                                }
                            }
                        }
                    }
                }
            }
            if (blockTDZVars.length > 0) {
                this.scopeManager.enterLocalsTDZ(context, blockTDZVars);
            }
            if (blockTDZVars.length > 0 && needsEnvironment) {
                const builder = this.vmCompilerUtils.createInstructionBuilder(context);
                for (const varName of blockTDZVars) {
                    if (blockVariables.includes(varName)) {
                        builder.declareTDZ(varName);
                    }
                }
            }
        }
        const blockDeclaredVars = new Set();
        for (const statement of node.body) {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(statement)) {
                for (const declaration of statement.declarations) {
                    const names = this.vmCompilerUtils.extractIdentifiersFromPattern(declaration.id);
                    for (const name of names) {
                        blockDeclaredVars.add(name);
                    }
                }
            }
            else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                blockDeclaredVars.add(statement.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isClassDeclarationNode(statement) && statement.id) {
                blockDeclaredVars.add(statement.id.name);
            }
        }
        const blockHoistedFunctions = new Set();
        if (!isFunctionBody) {
            for (const statement of node.body) {
                if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                    const funcName = statement.id.name;
                    let shadowsOuter = false;
                    for (let depth = context.blockScopeDepth - 1; depth >= 0; depth--) {
                        const scopedKey = (0, VMConstants_1.getScopedVariableName)(funcName, depth);
                        if (context.localVariables.has(scopedKey)) {
                            shadowsOuter = true;
                            break;
                        }
                    }
                    if (!shadowsOuter && context.localVariables.has(funcName)) {
                        shadowsOuter = true;
                    }
                    if (!shadowsOuter && context.parameters.has(funcName)) {
                        shadowsOuter = true;
                    }
                    if (!shadowsOuter && context.envVars.has(funcName)) {
                        shadowsOuter = true;
                    }
                    if (shadowsOuter) {
                        continue;
                    }
                    const referencedVars = this.vmCompilerUtils.collectReferencedIdentifiers(statement);
                    const paramNames = new Set();
                    for (const param of statement.params) {
                        if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                            paramNames.add(param.name);
                        }
                    }
                    const containsNestedFunction = this.vmCompilerUtils.containsFunction(statement.body);
                    let referencesBlockVar = false;
                    if (!containsNestedFunction) {
                        for (const varName of referencedVars) {
                            if (paramNames.has(varName)) {
                                continue;
                            }
                            if (varName === funcName) {
                                continue;
                            }
                            if (blockDeclaredVars.has(varName)) {
                                referencesBlockVar = true;
                                break;
                            }
                        }
                    }
                    if (!containsNestedFunction && !referencesBlockVar) {
                        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(statement);
                        blockHoistedFunctions.add(statement);
                    }
                }
            }
        }
        for (const statement of node.body) {
            if (blockHoistedFunctions.has(statement)) {
                continue;
            }
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.statement(statement);
        }
        for (const varName of blockTDZVars) {
            this.scopeManager.exitLocalTDZ(context, varName);
        }
        this.scopeManager.exitBlockWithHandle(context, blockHandle);
        if (envHandle) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            this.scopeManager.exitEnv(context, builder, envHandle);
        }
    }
    compileReturnStatement(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (node.argument) {
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.argument);
        }
        else {
            builder.pushUndefined();
        }
        builder.return();
    }
    compileIfStatement(node, context) {
        this.conditionalCompiler.compileIfStatement(node, context);
    }
    compileWhileStatement(node, context) {
        this.loopCompiler.compileWhileStatement(node, context);
    }
    compileDoWhileStatement(node, context) {
        this.loopCompiler.compileDoWhileStatement(node, context);
    }
    compileForStatement(node, context) {
        this.loopCompiler.compileForStatement(node, context);
    }
    compileForOfStatement(node, context) {
        this.loopCompiler.compileForOfStatement(node, context);
    }
    compileForInStatement(node, context) {
        this.loopCompiler.compileForInStatement(node, context);
    }
    compileBreakStatement(node, context) {
        if (node.label) {
            const labelName = node.label.name;
            const labelTarget = context.labelTargets.get(labelName);
            if (labelTarget !== undefined) {
                this.emitJumpWithEnvRestore(0, labelTarget, true, context);
            }
        }
        else if (context.breakTargets.length > 0) {
            const targetEnvDepth = context.breakEnvDepths[context.breakEnvDepths.length - 1];
            const sentinelTarget = context.breakTargets[context.breakTargets.length - 1];
            this.emitJumpWithEnvRestore(targetEnvDepth, sentinelTarget, true, context);
        }
    }
    compileContinueStatement(node, context) {
        if (node.label) {
            const labelName = node.label.name;
            const labelContinueTarget = context.labelContinueTargets.get(labelName);
            if (labelContinueTarget !== undefined) {
                this.emitJumpWithEnvRestore(0, labelContinueTarget, false, context);
            }
        }
        else if (context.continueTargets.length > 0) {
            const targetEnvDepth = context.continueEnvDepths[context.continueEnvDepths.length - 1];
            const target = context.continueTargets[context.continueTargets.length - 1];
            this.emitJumpWithEnvRestore(targetEnvDepth, target, false, context);
        }
    }
    compileThrowStatement(node, context) {
        this.exceptionCompiler.compileThrowStatement(node, context);
    }
    compileTryStatement(node, context) {
        this.exceptionCompiler.compileTryStatement(node, context);
    }
    compileSwitchStatement(node, context) {
        this.conditionalCompiler.compileSwitchStatement(node, context);
    }
    compileVariableDeclaration(node, context) {
        this.declarationCompiler.compileVariableDeclaration(node, context);
    }
    compileFunctionDeclaration(node, context) {
        this.declarationCompiler.compileFunctionDeclaration(node, context);
    }
    compileClassDeclaration(node, context) {
        this.classCompiler.compileClassDeclaration(node, context);
    }
    compileLabeledStatement(node, context) {
        var _a;
        const labelName = node.label.name;
        const labelEndSentinelIndex = context.instructions.length;
        context.labelTargets.set(labelName, labelEndSentinelIndex);
        context.breakTargets.push(labelEndSentinelIndex);
        context.breakEnvDepths.push(context.envDepth);
        const previousLabel = context.currentLabel;
        context.currentLabel = labelName;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(node.body);
        context.currentLabel = previousLabel;
        const actualEnd = context.instructions.length;
        this.vmCompilerUtils.patchLabeledBreakStatements(labelEndSentinelIndex, actualEnd, context);
        context.labelTargets.delete(labelName);
        context.labelContinueTargets.delete(labelName);
        context.breakTargets.pop();
        context.breakEnvDepths.pop();
    }
    emitJumpWithEnvRestore(targetEnvDepth, jumpTarget, isBreak, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const currentEnvDepth = context.envDepth;
        for (let i = currentEnvDepth; i > targetEnvDepth; i--) {
            builder.restoreParentEnv();
        }
        if (isBreak) {
            builder.break().patchTo(jumpTarget);
        }
        else {
            builder.continue().patchTo(jumpTarget);
        }
    }
};
exports.VMStatementBytecodeCompiler = VMStatementBytecodeCompiler;
exports.VMStatementBytecodeCompiler = VMStatementBytecodeCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMLoopCompiler)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMConditionalCompiler)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMExceptionCompiler)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMDeclarationCompiler)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMClassBytecodeCompiler)),
    __param(6, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object, typeof (_b = typeof IVMLoopCompiler_1.IVMLoopCompiler !== "undefined" && IVMLoopCompiler_1.IVMLoopCompiler) === "function" ? _b : Object, typeof (_c = typeof IVMConditionalCompiler_1.IVMConditionalCompiler !== "undefined" && IVMConditionalCompiler_1.IVMConditionalCompiler) === "function" ? _c : Object, typeof (_d = typeof IVMExceptionCompiler_1.IVMExceptionCompiler !== "undefined" && IVMExceptionCompiler_1.IVMExceptionCompiler) === "function" ? _d : Object, typeof (_e = typeof IVMDeclarationCompiler_1.IVMDeclarationCompiler !== "undefined" && IVMDeclarationCompiler_1.IVMDeclarationCompiler) === "function" ? _e : Object, typeof (_f = typeof IVMClassBytecodeCompiler_1.IVMClassBytecodeCompiler !== "undefined" && IVMClassBytecodeCompiler_1.IVMClassBytecodeCompiler) === "function" ? _f : Object, typeof (_g = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _g : Object])
], VMStatementBytecodeCompiler);
